/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');

  (function() {
    let linkList = document.querySelectorAll('.Linklist__Item');

    linkList.forEach(function(event) {
      event.addEventListener('mouseenter', function(event){
        event.target.classList.add('is-expanded')
      })

      event.addEventListener('mouseleave', function(event){
        event.target.classList.remove('is-expanded')
      })
    })
  })();

// Antipilling page JS 
  (function(){
    //Button Selects 
    const yarnButton = document.querySelector("#YarnButton");
    const antipillingButton = document.querySelector("#AntipillingButton");
    //Div Selects
    const yarnSection = document.querySelector(".antipilling-yarns");
    const aboutAntipilling = document.querySelector(".about-antipilling");
    let headerBarHeight = 122;
    
    if(!yarnButton || !antipillingButton) return;
    
    yarnButton.addEventListener('click', function(){
      if(window.innerWidth <= 640){
        headerBarHeight = 60;
      }else{
        headerBarHeight = 122;
      }
      
      const yarnScrollTo = window.scrollY + (yarnSection.getBoundingClientRect().top - headerBarHeight);
      window.scrollTo({top: yarnScrollTo, behavior:"smooth"});
    });
    
    antipillingButton.addEventListener('click', function(){
      if(window.innerWidth <= 640){
        headerBarHeight = 60;
      }else{
        headerBarHeight = 122;
      }
      
      const aboutScrollTo = window.scrollY + (aboutAntipilling.getBoundingClientRect().top - headerBarHeight);
      window.scrollTo({top: aboutScrollTo, behavior:"smooth"});
    });
  })();
